module.exports = __webpack_public_path__ + "static/media/process.a27d2ce2.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/wardrober/src/process.png
// module id = 573
// module chunks = 0